
import { Component, inject, input } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { TooltipDirective } from '@catch/directives';
import { isaQuestions } from '../../../constants/isaquestions';
import { ISAQuestion } from '../../../interfaces/isaquestion';
import { ColorService } from '../../../services/color.service';
import { AnimatedCheckComponent } from '../animated-check/animated-check.component';

@Component({
  selector: 'app-skill-test',
  templateUrl: './skill-test.component.html',
  styleUrls: ['./skill-test.component.scss'],
  imports: [FormsModule, TranslocoPipe, TooltipDirective, AnimatedCheckComponent],
})
export class SkillTestComponent {
  control = input.required<FormControl>();
  submitAttempt = input(false);
  sliderAutoForward = input(false);
  showIntroQuestion = input(false);
  index: number = 0;
  value: number = 3;
  questions: ISAQuestion[];
  nextTimeout;
  public completed: boolean = false;
  public colorService = inject(ColorService);

  constructor() {
    this.questions = isaQuestions
      .map((question, i) => {
        return {
          left: question.left,
          right: question.right,
          index: i,
          answer: 0,
        };
      })
      .sort(() => 0.5 - Math.random());
  }

  prev() {
    if (this.index !== 0) this.index--;
    this.value = this.questions[this.index].answer + 3;
  }

  next() {
    clearTimeout(this.nextTimeout);
    if (this.value === 3) return;

    if (this.questions[this.index + 1]?.answer) this.value = this.questions[this.index + 1].answer + 3;
    else this.value = 3;

    if (this.index < this.questions.length - 1) this.index++;
    else {
      this.control().patchValue(this.mappedValues);
    }
  }

  finish() {
    this.control().patchValue(this.mappedValues);
    this.completed = true;
  }

  sliderChange(event) {
    clearTimeout(this.nextTimeout);
    this.questions[this.index].answer = event.target.value - 3;
    if (
      this.sliderAutoForward &&
      this.questions[this.index + 1]?.answer === 0 &&
      this.index < this.questions.length - 1
    ) {
      this.nextTimeout = setTimeout(() => {
        this.next();
      }, 500);
    }
  }

  get mappedValues() {
    const result = [];
    this.questions.forEach(question => (result[question.index] = question.answer));
    return result;
  }
}
